export default __webpack_public_path__ + "static/char-thumb-48-2cc18bfeab817861041eb8f654d2840c.png";